import type { Types } from '../types';
import type { OutTypes } from './schedules';
import type { BaseOptions } from '../../common/types';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { ConfigurationVertex } from '../interfaces/vertices/configurations';

export default (
  configurations: Types.Mixed.Configuration[],
  _options:       BaseOptions
): OutTypes.configuration[] => {
  return configurations
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<ConfigurationVertex> = {
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<ConfigurationVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
